import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'confirmation-dialog-especial',
  templateUrl: '../../pages/confirmation-dialog/confirmation-especial-dialog.html',
})
export class ConfirmationDialogEspecial 
{
    message: string = "¿Esta seguro de anular la solicitud?"   
    botonStyleCancel: string = "margin-left:20%;"
    botonStyleAceptar: string = "margin-left:20%;"
    confirmButtonText = "Si"
    cancelButtonText = "No"
    
    constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogEspecial>) 
    {
        if(data)
        {
            this.message = data.message || this.message;
            this.botonStyleCancel=data.botonStyleCancel || this.botonStyleCancel;
            this.botonStyleAceptar=data.botonStyleAceptar || this.botonStyleAceptar;
            
            if (data.buttonText) 
            {
                this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
                this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
            }
        }
    }

    onConfirmClick(): void { this.dialogRef.close(true); }

    onRejectClick(): void { this.dialogRef.close(false); }
}